import {Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import {AbstractControl} from "@angular/forms";
import {HelperService} from "../../../services/helperService";


@Component({
	selector: "tig-form-error",
	template: `
		<div *ngIf="OBJ_form_control?.invalid">
			<span class="help-block m-b-none" *ngIf="OBJ_form_control.hasError('required')">
			  {{'oError.sRequired'|translate}}
			</span>
			<span class="help-block m-b-none" *ngIf="OBJ_form_control.hasError('minlength')">
			  {{ 'oError.sMinlength'|translate:{ value: OBJ_form_control.getError('minlength')?.requiredLength} }}
			</span>
			<span class="help-block m-b-none" *ngIf="OBJ_form_control.hasError('maxlength')">
			  {{ 'oError.sMaxlength'|translate:{value: OBJ_form_control.getError('maxlength')?.requiredLength} }}
			</span>
			<span class="help-block m-b-none" *ngIf="OBJ_form_control.hasError('min')">
			  {{'oError.sMin'|translate:{value: OBJ_form_control.getError('min').min } }}
			</span>
			<span class="help-block m-b-none" *ngIf="OBJ_form_control.hasError('max')">
			  {{'oError.sMax'|translate:{value:OBJ_form_control.getError('max').max} }}
			</span>
			<span class="help-block m-b-none" *ngIf="OBJ_form_control.hasError('pattern')">
			  {{'oError.sPattern'|translate:{value:this.getPatternHint(OBJ_form_control.getError('pattern')?.requiredPattern)|translate} }}
			</span>
			<span class="help-block m-b-none" *ngIf="OBJ_form_control.hasError('checkEmail')">
			  {{"oEmail.sInvalid"|translate}}
			</span>
			<span class="help-block m-b-none" *ngIf="OBJ_form_control.hasError('invalidNumber')">
			  {{"oError.sInvalidNumber"|translate}}
			</span>
			<span class="help-block m-b-none" *ngIf="OBJ_form_control.hasError('checkPassword')">
			  {{"oPassword.sInvalid"|translate}}
			</span>
			<span class="help-block m-b-none" *ngIf="OBJ_form_control.hasError('checkUrl')">
			  {{"oUrl.sInvalid"|translate}}
			</span>
			<span class="help-block m-b-none" *ngIf="OBJ_form_control.hasError('invalidImageFormat')">
			  {{"oFile.sInvalidImageFormat"|translate}}
			</span>
            <span class="help-block m-b-none" *ngIf="OBJ_form_control.hasError('invalidFileFormat')">
			  {{"oFile.sInvalidFileFormat"|translate}}
			</span>
            <span class="help-block m-b-none" *ngIf="OBJ_form_control.hasError('missingTranslation')">
			  {{"oError.sMissingTranslation"|translate}}
			</span>
            <span class="help-block m-b-none" *ngIf="OBJ_form_control.hasError('usernameRequired')">
			  {{"oError.sUsernameRequired"|translate}}
			</span>
            <span class="help-block m-b-none" *ngIf="OBJ_form_control.hasError('mailSend')">
			  {{"oError.sMailSend"|translate}}
			</span>
			<span class="help-block m-b-none" *ngIf="OBJ_form_control.hasError('ApiNotUnique')">
			  {{"oError.sNotUnique"|translate}}
			</span>
			<span class="help-block m-b-none" *ngIf="OBJ_form_control.hasError('json')">
			  {{"oError.sInvalidJson"|translate}}
			</span>
			<span class="help-block m-b-none" *ngIf="OBJ_form_control.hasError('backendError')">
			  {{"oError.sBackendError"|translate}}
			</span>
		</div>
  `
})
export class FormErrorComponent
{

	constructor(
		private OBJ_helper_service: HelperService
	)
	{}

    /** Attributes */
	@Input()
    OBJ_form_control: AbstractControl;

	/**
	 * @desc Falls vorhanden: Hole ausführlichere Beschreibung des benötigten patterns
	 * @param STR_required_pattern
	 */
	getPatternHint(STR_required_pattern)
	{
		return this.OBJ_helper_service.getPatternByRegex(STR_required_pattern);

	}
} // end class FormErrorComponent
